import {Button, ButtonProps, Form, FormProps, Modal, ModalProps, Radio} from "antd";
import {EditOutlined} from "@ant-design/icons";
import PermissionRoute from "../../Authentication/PermissionRoute";
import {isImpactSettingsEdit} from "../../Authentication/permissions";
import {useCallback, useState} from "react";
import {capitalize} from "lodash";
import {useTranslation} from "react-i18next";
import AntFormItem from "../../common/AntFormItem";
import CustomNumericFormat from "../../common/customNumeric/CustomNumericFormat";
import {ImpactItemType} from "./ImpactSettings";
import {useForm} from "antd/lib/form/Form";

function ImpactSettingsForm({formProps}: { formProps?: FormProps }) {

  const {t} = useTranslation();

  return <Form
    layout={"vertical"}
    {...formProps}
  >
    <AntFormItem
      name={"magnitude"}
      label={`${capitalize(t('hazards.vulnerability.magnitude'))} (1-5)`}
      rules={[{required: true}]}
    >
      <CustomNumericFormat
        decimalScale={0}
        fixedDecimalScale={true}
        isAllowed={(values) => {
          const {floatValue} = values;
          return floatValue === undefined || (floatValue >= 1 && floatValue <= 5);
        }}
      />
    </AntFormItem>
    <AntFormItem
      name={"to_be_used_in_impact"}
      label={capitalize(t('settings.impactVisible'))}
      rules={[{required: true}]}
    >
      <Radio.Group>
        <Radio value={true}>{capitalize(t('misc.yes'))}</Radio>
        <Radio value={false}>{capitalize(t('misc.no'))}</Radio>
      </Radio.Group>
    </AntFormItem>
  </Form>
}

export default function ImpactSettingsEdit({buttonProps, modalProps, impact, onFinish}: {
  buttonProps?: ButtonProps,
  modalProps?: ModalProps,
  impact: ImpactItemType,
  onFinish?: (values: { magnitude: number, to_be_used_in_impact: boolean }) => void,
}) {

  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [form] = useForm()

  const handleFinish = useCallback((values: { magnitude: number, to_be_used_in_impact: boolean }) => {
    onFinish?.(values);
    setIsOpen(false);
  }, [onFinish]);

  return <PermissionRoute
    isAuthorized={isImpactSettingsEdit}
  >
    <Modal
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      title={capitalize(t('settings.editImpactParameters', {label: impact.label}))}
      children={<ImpactSettingsForm
        key={impact.uuid}
        formProps={{
          initialValues: {
            magnitude: impact.magnitude,
            to_be_used_in_impact: impact.to_be_used_in_impact
          },
          form,
          onFinish: handleFinish,
        }}
      />}
      footer={<Button
        type={"primary"}
        onClick={() => form.submit()}
      >
        {capitalize(t('actions.save'))}
      </Button>}
      {...modalProps}
    />
    <Button
      icon={<EditOutlined/>}
      type={"text"}
      onClick={() => {
        form.resetFields()
        setIsOpen(true)
      }}
      {...buttonProps}
    />
  </PermissionRoute>
}